import http from 'hub-http/clients/apiClient';
export const requestFetchPersonalizationVariants = ({
  id
}) => http.get(`cospages/v2/landing-pages/${id}/personalized-variants`);